module.exports = __webpack_public_path__ + "img/legend-checkin.eb280ed3.svg";